import { HttpParams } from '@angular/common/http';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SubSink } from 'subsink';
import * as moment from 'moment';
import { CALENDAR_LOCALE } from '../../../services/constant';
import { DownloadService } from '../download.service';
import { TranslateService } from '@ngx-translate/core';
import { TemplateService } from '../../../services/template.service';
import { ApiService } from '../../../services/api.service';
import * as _ from 'lodash';
var DownloadListComponent = (function () {
    function DownloadListComponent(apiService, modalService, downloadService, template, translate) {
        this.apiService = apiService;
        this.modalService = modalService;
        this.downloadService = downloadService;
        this.template = template;
        this.translate = translate;
        this.startDate = new Date(moment().format('YYYY') + '-01-01');
        this.endDate = new Date(moment().format('YYYY') + '-12-30');
        this.loading = false;
        this.currentPage = 1;
        this.itemsPerPage = 40;
        this.totalItems = 0;
        this.documentList = [];
        this.approvedList = [];
        this.rejectedList = [];
        this.isLoadingConfirm = false;
        this.showResults = false;
        this.successEmailList = [];
        this.failedEmailList = [];
        this.documentNumber = '';
        this.email = '';
        this.docTypeList = null;
        this.poNumber = '';
        this.calendarLocale = CALENDAR_LOCALE.TH;
        this.isCheckAll = false;
        this.subs = new SubSink();
        this.tableCol = [];
        this.defaultLabel = null;
    }
    DownloadListComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.selectedCustomercode = null;
        this.selectedRdDocumentType = null;
        this.translate.onLangChange.subscribe(function (event) {
            _this.getDocumentRequestList();
        });
        this.getDocumentRequestList();
        this.rdDocumentType = this.template.getDropdown();
    };
    DownloadListComponent.prototype.getDocumentRequestList = function () {
        var _this = this;
        this.defaultLabel = this.translate.instant('COMMON.ALL');
        this.tableCol = [];
        if (this.translate.currentLang === 'en') {
            this.calendarLocale = CALENDAR_LOCALE.EN;
        }
        else {
            this.calendarLocale = CALENDAR_LOCALE.TH;
        }
        this.loading = true;
        var params = new HttpParams()
            .set('page_size', this.itemsPerPage.toString())
            .set('page', this.currentPage.toString())
            .set('status', 'False')
            .set('email', this.email)
            .set('customer_code', this.selectedCustomercode)
            .set('po_number', this.poNumber)
            .set('rd_doc_type', this.selectedRdDocumentType)
            .set('start_date', this.startDate ? moment(this.startDate).format('YYYY-MM-DD') : '')
            .set('end_date', this.endDate ? moment(this.endDate).format('YYYY-MM-DD') : '')
            .set('document_number', this.documentNumber);
        this.translate.get('COMMON.ALL').subscribe(function (res) {
            var documentTypeData = _this.template.getDropdown();
            // documentTypeData[0] = {label: this.translate.instant('COMMON.ALL'), value: null};
            _this.rdDocumentType = documentTypeData;
            _this.loadInput();
            _this.subs.add(_this.downloadService.getDocumentRequestList(params).subscribe(function (documents) {
                _this.documentList = documents['results'];
                _this.totalItems = documents['count'];
                _this.loading = false;
            }, function (error) {
                console.log('error', error);
            }));
        });
    };
    DownloadListComponent.prototype.loadInput = function () {
        var _this = this;
        this.customerCode = [{
                label: this.translate.instant('COMMON.ALL'),
                value: null
            }];
        var params = new HttpParams();
        params = params.append('none_pagination', 'true');
        this.apiService.getCustomerList(params).subscribe(function (result) {
            _.forEach(result, function (obj) {
                _this.customerCode.push({
                    label: obj.c_code,
                    value: obj.c_code
                });
            });
            _this.customerCode = _.uniqBy(_this.customerCode, 'label');
        }, function (error) {
            console.log('error', error);
        });
    };
    Object.defineProperty(DownloadListComponent.prototype, "yearRange", {
        get: function () {
            var thisYear = new Date().getFullYear();
            return thisYear - 40 + ':' + thisYear;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DownloadListComponent.prototype, "dateRange", {
        get: function () {
            var start = moment(this.startDate).format('DD/MM/YYYY');
            var end = moment(this.endDate).format('DD/MM/YYYY');
            return start + ' - ' + end;
        },
        enumerable: true,
        configurable: true
    });
    DownloadListComponent.prototype.search = function () {
        this.currentPage = 1;
        this.getDocumentRequestList();
    };
    DownloadListComponent.prototype.clearSearch = function () {
        this.documentNumber = '';
        this.startDate = new Date(moment().format('YYYY') + '-01-01');
        this.endDate = new Date(moment().format('YYYY') + '-12-30');
        this.email = '';
        this.customerCode = '';
        this.poNumber = '';
        this.getDocumentRequestList();
    };
    DownloadListComponent.prototype.setMinDate = function () {
        this.minDate = this.startDate;
        if (this.endDate < this.minDate) {
            this.endDate = this.minDate;
        }
    };
    DownloadListComponent.prototype.setMaxDate = function () {
        this.maxDate = this.endDate;
        if (this.startDate > this.maxDate) {
            this.startDate = this.maxDate;
        }
    };
    DownloadListComponent.prototype.open = function (content) {
        this.showResults = false;
        this.modal = this.modalService.open(content);
    };
    DownloadListComponent.prototype.toggleStatusChange = function () {
        this.approvedList = this.documentList.filter(function (obj) { return obj.status; });
        this.rejectedList = this.documentList.filter(function (obj) { return obj.status; });
    };
    DownloadListComponent.prototype.confirm = function () {
        var _this = this;
        this.isLoadingConfirm = true;
        this.errorMessage = null;
        this.subs.add(this.downloadService.updateDocumentRequest(this.approvedList).subscribe(function (res) {
            _this.successEmailList = res.success_email_list;
            _this.failedEmailList = res.failed_email_list;
        }, function (error) {
            console.log('error', error);
            _this.checkErrorMsg(error);
            _this.isLoadingConfirm = false;
        }, function () {
            _this.isLoadingConfirm = false;
            _this.showResults = true;
            _this.approvedList = [];
            _this.getDocumentRequestList();
        }));
    };
    DownloadListComponent.prototype.reject = function () {
        var _this = this;
        this.isLoadingConfirm = true;
        this.errorMessage = null;
        this.subs.add(this.downloadService.rejectDocumentRequest(this.approvedList).subscribe(function (res) {
            _this.successEmailList = res.success_email_list;
            _this.failedEmailList = res.failed_email_list;
        }, function (error) {
            console.log('error', error);
            _this.checkErrorMsg(error);
            _this.isLoadingConfirm = false;
        }, function () {
            _this.isLoadingConfirm = false;
            _this.showResults = true;
            _this.rejectedList = [];
            _this.getDocumentRequestList();
        }));
    };
    DownloadListComponent.prototype.checkErrorMsg = function (error) {
        // this.errorMsgForShow = this.apiService.getErrorMessage(error);
        var errormsg = (error.error.message[0]);
        if (this.translate.currentLang === 'en') {
            this.errorMessage = errormsg;
        }
        else {
            this.errorMessage = '';
        }
    };
    DownloadListComponent.prototype.checkAll = function () {
        var _this = this;
        this.documentList.map(function (obj) {
            obj['status'] = _this.isCheckAll;
        });
        this.toggleStatusChange();
    };
    DownloadListComponent.prototype.deleteDownloadRequest = function (id) {
        var _this = this;
        this.downloadService.deleteDocumentRequest(id).subscribe(function () {
            _this.documentList = _this.documentList.filter(function (obj) { return obj.id !== id; });
        }, function (error) { return console.log('error', error); });
    };
    DownloadListComponent.prototype.optionChanged = function () {
        this.getDocumentRequestList();
    };
    DownloadListComponent.prototype.pageChanged = function () {
        this.getDocumentRequestList();
    };
    DownloadListComponent.prototype.ngOnDestroy = function () {
        this.subs.unsubscribe();
    };
    return DownloadListComponent;
}());
export { DownloadListComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/download/download-list/download-list.component.ts.pre-build-optimizer.js